var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.orders),function(order){return _c('div',{key:order.id},[_c('notification-order-item',{attrs:{"order":order}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }